export const CART_ITEMS_QUERY_KEY = (userId = null) => ["cart_items", userId];